import { render, staticRenderFns } from "./CustomerLink.vue?vue&type=template&id=46a0303a&functional=true&"
import script from "./CustomerLink.vue?vue&type=script&lang=js&"
export * from "./CustomerLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports